export default {
      id: "download_template-usage",
      viewBox: "0 0 20 19",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#download_template",
      toString: function () {
        return this.url;
      }
    }